/**
 * ⟦C48 · A-168 §3⟧ **Le cadre de l'Atelier** : l'enveloppe de tous ses écrans (intro d'étape, jeu,
 * score, « Prêt à publier », résultat de publication, résultat d'un jalon) est une `Fenetre` sur le
 * fond de la chambre (`EcranFenetre.tsx`) au lieu d'une page de papier sur l'aplat jaune. Le
 * bandeau porte « L'Atelier » et le sujet en badge ; les cartes de papier (`.carte`) restent EN
 * DEDANS, comme dans les autres fenêtres (« Nouvelle vidéo » a les mêmes sous-panneaux).
 *
 * Ce fichier ne touche à aucun mini-jeu (`client/src/atelier/`, chantier C47) : il ne fait que
 * remplacer l'ancien `<main className="ecran ecran-atelier">`.
 */

import type { ReactNode } from "react";

import { EcranFenetre } from "../../components/EcranFenetre";

export function CadreAtelier({ sujet, children }: { sujet?: string; children: ReactNode }) {
  return (
    <EcranFenetre
      titre="L'Atelier"
      icone="🎬"
      badge={sujet ? `« ${sujet} »` : undefined}
      large
      className="fenetre-atelier"
    >
      {children}
    </EcranFenetre>
  );
}
